import Button from '../ui_components/button/button';
import {
  Modal,
  ModalActions as ModalActionsE,
  ModalContent,
  ModalHeader as ModalHeaderE,
  ModalProps,
} from '../ui_components/modal';
import PageDimmer from '../ui_components/dimmer/PageDimmer';
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '../theme';

const noop = () => {
  /* ignore */
};

export interface ClientsImportModal
  extends Pick<
    ModalProps,
    | 'uiActive'
    | 'uiOnRequestClose'
    | 'className'
    | 'uiOnClose'
    | 'uiTransitionTimeout'
    | 'uiCloseOnEsc'
    | 'uiCloseOnOutsideClick'
  > {
  /**
   * Modal header
   */
  uiHeader?: string;
  /**
   * Accept button label
   */
  uiAcceptLabel?: string | false;

  uiDeclineLabel?: string | false;
  /**
   * Close modal when pressing Esc
   * @default true
   */
  uiCloseOnEsc?: boolean;
  /**
   * Close modal on outside click
   * @default true
   */
  uiCloseOnOutsideClick?: boolean;
  /**
   * Class name
   */
  className?: string;
  /**
   * Child
   */
  children?: React.ReactNode;
  /**
   * Confirmation callback
   */
  uiOnConfirm(res?: unknown): void;

  /**
   * Edit Work Order condition
   */
  workOrderEditMode?: boolean;

  /**
   * Cancel editing Work Order
   */
  cancelEditing?(): void;
}

const ClientsImportContent = styled(ModalContent)`
  display: flex !important;
  flex-flow: row wrap !important;
  align-items: center !important;
  color: ${theme.colors.grayRGBA};
`;

const StyledModal = styled(Modal)`
  max-width: 500px !important;
  border-radius: 0.5rem !important;
  box-shadow: rgba(59, 151, 177, 0.2) 1px 3px 3px 0px, rgba(59, 151, 177, 0.2) 1px 3px 15px 2px !important;
  border: solid ${theme.colors.grayRGBA} 1px !important;
  ${breakpoints.down(
    'sm',
    css`
      max-width: 90% !important;
    `
  )};
`;

const ModalHeader = styled(ModalHeaderE)`
  //   color: ${theme.colors.primary};
  border-bottom: none !important;
  padding-bottom: 0.25rem !important;
  font-size: 18px !important;
  font-weight: 500 !important;
`;

const ModalActions = styled(ModalActionsE)`
  border-bottom-left-radius: 0.5rem !important;
  border-bottom-right-radius: 0.5rem !important;
  justify-content: flex-end !important;
  padding: 0.7rem 1rem !important;
`;

const BasicButton = styled(Button)`
  // width: 130px;
  box-shadow: none;
  border: 1px solid #c6c6c6;
  border-radius: 0.5em;
  display: block;
`;

const CancelButton = styled(Button)`
  box-shadow: none !important;
  background-color: transparent !important;
  border: none !important;

  &:hover {
    background-color: #eeeeee !important;
  }
`;

const ConfirmButton = styled(BasicButton)`
  border-radius: 5px;
  // width: 100px;
  box-shadow: none !important;
  line-height: 0.6rem !important;
  &:hover {
    background: #c6c6c6 !important;
  }
  margin-left: ${(props) => (props.className === 'pop-up' ? 'auto' : 'initial')};
`;

/**
 * Simple confirmation modal
 */
export const ClientsImportModal: React.FC<ClientsImportModal> = (props) => {
  const leftButtonAction = props.uiOnRequestClose;
  const rightButtonAction = props.uiOnConfirm;
  return (
    <StyledModal
      className={props.className}
      uiActive={props.uiActive}
      uiOnRequestClose={noop}
      uiDefaultSizes={false}
      uiOnClose={props.uiOnClose}
      uiTransitionTimeout={props.uiTransitionTimeout}
      uiCloseOnOutsideClick={props.uiCloseOnOutsideClick}
      uiCloseOnEsc={props.uiCloseOnEsc}
    >
      {props.uiAcceptLabel === 'Setup' && props.uiHeader === 'Setup Needed' && (
        <PageDimmer uiActive />
      )}
      <ModalHeader>{props.uiHeader}</ModalHeader>

      <ClientsImportContent>{props.children}</ClientsImportContent>
      <ModalActions>
        {props.uiDeclineLabel && (
          <CancelButton
            id="confirm"
            uiColor="primary"
            onClick={leftButtonAction}
            className={`${props.className} cancel_btn`}
          >
            Cancel
          </CancelButton>
        )}
        {props.uiAcceptLabel && (
          <ConfirmButton
            id="confirm"
            uiColor="primary"
            onClick={rightButtonAction}
            className={props.className}
          >
            Proceed
          </ConfirmButton>
        )}
      </ModalActions>
    </StyledModal>
  );
};

ClientsImportModal.defaultProps = {
  uiHeader: 'Info!',
  uiAcceptLabel: 'Close',
  uiDeclineLabel: 'Close',
};
